import { render, staticRenderFns } from "./Adicionais.vue?vue&type=template&id=0596a076&scoped=true"
import script from "./Adicionais.vue?vue&type=script&lang=js"
export * from "./Adicionais.vue?vue&type=script&lang=js"
import style0 from "./Adicionais.vue?vue&type=style&index=0&id=0596a076&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0596a076",
  null
  
)

export default component.exports